<template>
    <a-spin :spinning="spinning" tip="Loading...">
        <div class="card mb-3">
            <div class="row no-gutters">
                <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-7">
                               
                                <div class="row">
                                    <div class="col-md-7">
                                        <base-input alternative="" label="From"><br>
                                            <a-range-picker v-model="inputDate" :showTime="{ format: 'hh:mm' }"
                                                format="MM-DD-YYYY hh:mm A" :placeholder="['Start Date', 'End Date']"
                                                style="width:100%" />
                                        </base-input>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-7">
                                        <base-input alternative="" label="Select Site">
                                            <a-select v-model="inputSite" showSearch
                                                placeholder="All Sites" optionFilterProp="children" style="width: 100%"
                                                :filterOption="filterOption" :disabled="site_type != 'ho'">
                                                <a-select-option v-for="option in siteOptions" :key="option.id"
                                                    :value="option.id">{{ option.name }}</a-select-option>
                                            </a-select>
                                        </base-input>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-7">
                                        <base-input alternative="" label="Select Supplier">
                                            <a-select mode="multiple" v-model="inputSupplier" showSearch
                                                placeholder="All Suppliers" optionFilterProp="children" style="width: 100%"
                                                :filterOption="filterOption" >
                                                <a-select-option v-for="option in supplierOptions" :key="option.id"
                                                    :value="option.id">{{ option.name }}</a-select-option>
                                            </a-select>
                                        </base-input>
                                    </div>
                                </div>

                            </div>
                            <div class="col-md-4 align-self-center">
                                <div v-if="reportDescription != ''" class="card">
                                    <div class="card-body">
                                        <div class="card-text">
                                            {{ reportDescription }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <br>
                                <button class="btn btn-sm btn-default float-right"
                                    style="border-radius: 24px; border:0px; width: 20%;"
                                    @click.prevent="generateSalesConsignmentPdf">Generate Report in PDF</button> &nbsp; &nbsp;
                                <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right"
                                    style="border-radius: 24px; border:0px; width: 20%;"
                                    @click.prevent="generateSalesConsignmentFile">Generate Report</button> &nbsp; &nbsp;

                                <vue-json-to-csv v-if="JsonData.length > 0" :json-data="JsonData"
                                    :csv-title="currentProfile.replace(/_/g, '-') + '-' + currDate.replace(/ /g, '_')">
                                    <button id='clickCsvExport' class="btn btn-sm btn-success float-right"
                                        style="border-radius: 24px; border:0px; width: 20%;"> Download CSV </button>
                                    &nbsp; &nbsp;
                                </vue-json-to-csv>
                                <button v-if="JsonData.length > 0" class="btn btn-sm btn-success float-right"
                                    style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateSalesConsignmentExcel">
                                    Download excel </button> &nbsp; &nbsp;
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="toggleAdvanceFilter" id="hide" class="col-md-12">
                <a-drawer title="" width="500" placement="right" @close="closeFilter" :visible="advancedFilterVisible">
                    <advance-filter :parentParams="advancedFilterParams" @changeParams="changeParams"
                        @closeFilter="closeFilter"></advance-filter>
                </a-drawer>
            </div>
        </div>
    </a-spin>
</template>

<script>
import HTTPRequest from '../../controllers/httpRequest.js'
import secureStorage from '../../controllers/secureStorage';
import AdvanceFilter from '../Bir Reports/ReportAdvanceFilter'
import reportUtils from '../../components/reportUtils'
import moment from 'moment';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import VueJsonToCsv from 'vue-json-to-csv';
import * as ExcelJS from "exceljs";
import { saveAs } from "file-saver";

import {
    mapState,
    mapActions
} from 'vuex'
import { getReportDescription } from '../../utilities';

var component_x;

export default {
    components: {
        AdvanceFilter, VueJsonToCsv
    },
    data() {
        return {
            spinning: false,
            inputDate: [moment().startOf('day'), moment().endOf('day')],
            inputGroupBy: '',
            groupOptions: [
                { key: '', value: 'No Grouping' },
                { key: 'supplier_id', value: 'Supplier' },
                { key: 'supplier_type_id', value: 'Supplier Type, Supplier' }
            ],
            site_type: '',
            selectedSiteName: secureStorage.getItem("defaultSiteName") || '',
            inputSite: [],
            siteOptions: [],
            inputSupplier: [],
            supplierOptions: [],
            inputLocation: [],
            locationOptions: [],
            headerExcelInfo: "",
            isShowTotalAmountWithoutTax: false,
            isShowSalesmanComm: false,
            isNetReturn: false,

            inputSortBy: 'id',
            sortOptions: [
                { key: 'id', value: 'Product Code' },
                { key: 'barcode', value: 'Barcode' },
                { key: 'name', value: 'Name or Description' },
                { key: 'total_amount', value: 'Total Amount' },
                { key: 'qty', value: 'Total Quantity' }
            ],
            currDate: moment().format("L_LT").split(":").join(";"),
            isSeparateSite: true,
            isShowDetail: true,
            isShowReferenceCode: false,
            inputFrom: moment().startOf('month'),
            inputTo: moment().endOf('month'),
            monthFormat: 'MM/YYYY',
            birSalesReports: [],
            toggleAdvanceFilter: false,
            toggleLabel: "Advanced Filter",
            advancedFilterParams: {},
            params: {},
            advancedFilterVisible: true,

            showSortInfo: 'asc',
            inputShowTop: 0,
            JsonData: [],
            accessRights: [],
            accessCostPriceRights: [],
            reportDescription: ''
        }
    },
    mounted: async function () {
        component_x = this;

        var userId = secureStorage.getItem("userId")
        var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
        component_x.siteOptions = Array.isArray(sites) ? sites : (sites.data || []);
        component_x.sort(component_x.siteOptions);

        var suppliers = await HTTPRequest.getRequest(component_x.endPoint + "suppliers/", null);
        component_x.supplierOptions = suppliers.data;
        component_x.sort(component_x.supplierOptions);

        if (component_x.categoriesOptions.length == 0) {
            var options = await HTTPRequest.getRequest(this.endPoint + 'categories/cascader_view', null);
            component_x.updateCategoriesOptions(options)
        }

        this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view', null)

        let siteId = secureStorage.getItem("defaultSiteId")
        this.inputSite = [siteId]
        const selectedSite = this.siteOptions.find(siteOption => String(siteOption.id) == String(siteId))
        if (selectedSite) {
            this.selectedSiteName = selectedSite.name || selectedSite.site_name || selectedSite.code || this.selectedSiteName
        }


        let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
        site = site && site.data ? site.data : site
        site = site && site.site ? site.site : site
        if (site != undefined) {
            this.site_type = site.site_type
            this.selectedSiteName = site.name || site.site_name || site.code || this.selectedSiteName
        }

        this.reportDescription = await getReportDescription(this.currentProfile)
        this.accessRights = this.$attrs.access_rights || []
        this.accessCostPriceRights = this.$attrs.access_costprice_rights || []
    },
    computed: {
        ...mapState(['currentProfile', 'endPoint', 'categoriesOptions']),
    },
    watch: {
        inputLocation: {
            handler: 'handleInputLocationChange',
            deep: true
        }
    },
    methods: {
        ...mapActions(['updateCategoriesOptions']),
        moment,
        async onLocationChange() {
            const sites = await HTTPRequest.getRequest(component_x.endPoint + 'sites/get_valid_sites?location_id=' + this.inputLocation[this.inputLocation.length - 1], null)
            this.siteOptions = Array.isArray(sites) ? sites : (sites.data || [])
            this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view', null);
            this.inputSite = this.siteOptions.map(s => s.id);
        },
        filterOption(input, option) {
            return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
        },
        // Advanced Info
        showSortInfoDiv() {
            this.showSortInfo == 'asc' ? this.showSortInfo = 'desc' : this.showSortInfo = 'asc'
        },
        autoChange(e) {
            if (e.target.value == '') {
                this.isShowDetail = true
            }
        },
        sortChange(e) {
            if (e.target.value != 'total_amount' || e.target.value != 'qty') {
                this.inputShowTop = 0
            }
        },
        sort(data) {
            data.sort(function (a, b) {
                return a.name.localeCompare(b.name);
            });
        },
        convertToCurrency(num) {
            return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        },
        async convertDecimal(num) {
            let number = 0;
            if (Number.isInteger(num)) {
                number = num.toFixed(0)
            } else {
                number = num.toFixed(4)
            }
            return await number
        },
        advanceFilter(value) {
            this.toggleAdvanceFilter = value
            if (this.toggleAdvanceFilter == true) {
                this.toggleLabel = "Collapse Filter"
            } else {
                this.toggleLabel = "Advanced Filter"
            }
        },
        closeFilter() {
            this.advanceFilter(false)
        },
        changeParams(params, actualParams, mode) {
            this.params = params
            this.advancedFilterParams = actualParams

            if (mode == 'filter') {
                this.advanceFilter(false);
            }
        },
        async handleInputLocationChange(newVal) {
            if (!newVal || newVal.length === 0) {
                var userId = secureStorage.getItem("userId");
                var sites = await HTTPRequest.getRequest(this.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
                this.siteOptions = Array.isArray(sites) ? sites : (sites.data || []);
                this.sort(this.siteOptions);
                this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view', null)
                let siteId = secureStorage.getItem("defaultSiteId");
                this.inputSite = [siteId]
                const selectedSite = this.siteOptions.find(siteOption => String(siteOption.id) == String(siteId))
                if (selectedSite) {
                    this.selectedSiteName = selectedSite.name || selectedSite.site_name || selectedSite.code || this.selectedSiteName
                }
            }
        },
        buildSalesConsignmentParameters() {
            let { from_date, to_date } = reportUtils.buildFromToHeaders(component_x, this.inputGroupBy, this.inputDate)
            return {
                "site_id": this.getSelectedSiteIds().toString(),
                "supplier_id": this.inputSupplier.toString(),
                "date_from": from_date,
                "date_to": to_date,
                ...((this.inputLocation.length > 0) && { "location_path": this.inputLocation.toString() }),
                "advanced_filter": this.params
            }
        },
        getSelectedSiteIds() {
            if (Array.isArray(this.inputSite)) {
                return this.inputSite.filter(siteId => siteId !== undefined && siteId !== null && siteId !== "")
            }

            if (this.inputSite === undefined || this.inputSite === null || this.inputSite === "") {
                return []
            }

            return [this.inputSite]
        },
        getSalesConsignmentColumns() {
            return [
                { key: "product_name", label: "Description", width: 85 },
                { key: "price", label: "Retail Price", width: 28, numeric: true },
                { key: "sold", label: "Sold", width: 22, numeric: true, total: true },
                { key: "total", label: "Total", width: 26, numeric: true, total: true },
                { key: "rate", label: "Rate", width: 22, numeric: true },
                { key: "net_unit_price", label: "Net Unit Price", width: 30, numeric: true },
                { key: "payable", label: "Payable", width: 28, numeric: true, total: true }
            ]
        },
        formatReportHeader(key) {
            return key
                .replace(/_/g, " ")
                .replace(/\w\S*/g, word => word.charAt(0).toUpperCase() + word.substr(1).toLowerCase())
        },
        formatReportValue(value, column) {
            if (value === undefined || value === null) {
                return ""
            }

            if (column.numeric && value !== "") {
                const numberValue = Number(value)
                return Number.isFinite(numberValue) ? this.convertToCurrency(numberValue) : ""
            }

            return String(value)
        },
        async fetchSalesConsignmentReport() {
            const parameters = this.buildSalesConsignmentParameters()
            const response = await HTTPRequest.getRequest(this.endPoint + 'sales_consignment_report?', parameters);

            if (response.error) {
                reportUtils.openNotificationWithIcon(component_x, 'error', response.error);
                return null
            }

            if (response.data && Array.isArray(response.data)) {
                return response.data
            }

            return Array.isArray(response) ? response : []
        },
        buildEmptySalesConsignmentJsonRow(columns) {
            const emptyRow = {}
            columns.forEach(column => {
                emptyRow[column.label] = ""
            })
            return emptyRow
        },
        buildSalesConsignmentTotalRow(rows, columns) {
            const totalRow = {}
            columns.forEach((column, index) => {
                if (index == 0) {
                    totalRow[column.label] = "Supplier Total :"
                } else if (column.total) {
                    const total = rows.reduce((sum, row) => {
                        const value = Number(row[column.key] || 0)
                        return sum + (Number.isFinite(value) ? value : 0)
                    }, 0)
                    totalRow[column.label] = this.convertToCurrency(total)
                } else {
                    totalRow[column.label] = ""
                }
            })
            return totalRow
        },
        buildSalesConsignmentJson(rows) {
            const columns = this.getSalesConsignmentColumns()
            const jsonData = []
            const groupedRows = this.groupSalesConsignmentBySupplier(rows)

            groupedRows.forEach(group => {
                const supplierRow = {}
                columns.forEach((column, index) => {
                    supplierRow[column.label] = index == 0 ? "Supplier: " + group.supplierName : ""
                })
                jsonData.push(supplierRow)

                group.rows.forEach(row => {
                    const formattedRow = {}
                    columns.forEach(column => {
                        formattedRow[column.label] = this.formatReportValue(row[column.key], column)
                    })
                    jsonData.push(formattedRow)
                })

                jsonData.push(this.buildSalesConsignmentTotalRow(group.rows, columns))
                jsonData.push(this.buildEmptySalesConsignmentJsonRow(columns))
            })

            return jsonData
        },
        groupSalesConsignmentBySupplier(rows) {
            const groups = []
            rows.forEach(row => {
                const supplierName = row.supplier_name || "No Supplier"
                let group = groups.find(item => item.supplierName == supplierName)
                if (!group) {
                    group = {
                        supplierName,
                        rows: []
                    }
                    groups.push(group)
                }
                group.rows.push(row)
            })
            return groups
        },
        getSelectedSiteText() {
            const selectedSiteIds = this.getSelectedSiteIds()
            if (selectedSiteIds.length == 0) {
                return this.site_type != 'ho' && this.selectedSiteName ? this.selectedSiteName : "All Sites"
            }

            let site_text = ""
            for (var s = 0; s < selectedSiteIds.length; s++) {
                const site = this.siteOptions.find(x => String(x.id) == String(selectedSiteIds[s]))
                if (site) {
                    const siteName = site.name || site.site_name || site.code || site.id
                    site_text += site_text == "" ? siteName : ", " + siteName
                }
            }

            if (site_text == "" && selectedSiteIds.length == 1 && String(selectedSiteIds[0]) == String(secureStorage.getItem("defaultSiteId"))) {
                site_text = this.selectedSiteName
            }

            return site_text || "All Sites"
        },
        getSelectedSupplierText() {
            if (this.inputSupplier.length == 0) {
                return "All Suppliers"
            }

            let supplier_text = ""
            for (var s = 0; s < this.inputSupplier.length; s++) {
                const supplier = this.supplierOptions.find(x => String(x.id) == String(this.inputSupplier[s]))
                if (supplier) {
                    supplier_text += supplier_text == "" ? supplier.name : ", " + supplier.name
                }
            }

            return supplier_text || "All Suppliers"
        },
        generateSalesConsignmentPdf: async function () {
            this.spinning = true;
            this.JsonData = [];

            let { from_header, to_header } = reportUtils.buildFromToHeaders(component_x, this.inputGroupBy, this.inputDate)
            const reportRows = await this.fetchSalesConsignmentReport()

            if (reportRows == null) {
                this.spinning = false;
                return
            }

            if (reportRows.length < 1) {
                reportUtils.openNotificationWithIcon(component_x, 'warning', 'Try increasing the scope by adjusting the filters.');
                this.spinning = false;
                return
            }

            const columns = this.getSalesConsignmentColumns()
            const headers = [columns.map(column => ({
                content: column.label,
                styles: { halign: 'center', valign: 'center' }
            }))]

            const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'legal' });
            const reportLogo = document.getElementById('reportLogo');
            if (reportLogo) {
                doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);
            }

            doc.setFontSize(14);
            doc.setFontType("bold");
            doc.text(15, 20, "Sales Consignment Report")
            doc.setFontType("normal");
            doc.setFontSize(10);
            doc.text(15, 25, "For the Period of " + from_header + " to " + to_header)
            doc.text(15, 30, doc.splitTextToSize("Site/s: " + this.getSelectedSiteText(), 250))
            doc.text(15, 35, doc.splitTextToSize("Supplier/s: " + this.getSelectedSupplierText(), 250))

            const colStyles = {}
            columns.forEach((column, index) => {
                colStyles[index] = { cellWidth: column.width }
            })

            let startY = 45
            const groupedRows = this.groupSalesConsignmentBySupplier(reportRows)
            groupedRows.forEach(group => {
                if (startY > 160) {
                    doc.addPage();
                    startY = 20
                }

                doc.setFontType("bold");
                doc.text(15, startY, "Supplier: " + group.supplierName)
                doc.setFontType("normal");

                const reportData = group.rows.map(row => columns.map(column => {
                    const value = this.formatReportValue(row[column.key], column)
                    if (column.key == "product_name") {
                        return { content: value, styles: { halign: 'left' } }
                    }
                    return value
                }))

                const totals = {}
                columns.forEach(column => {
                    if (column.total) {
                        totals[column.key] = group.rows.reduce((sum, row) => sum + Number(row[column.key] || 0), 0)
                    }
                })

                reportData.push(["rowLine"])
                reportData.push(columns.map((column, index) => {
                    if (index == 0) {
                        return { content: "Supplier Total :", styles: { halign: 'right', fontStyle: 'bold' } }
                    }

                    if (totals[column.key] !== undefined) {
                        return this.convertToCurrency(totals[column.key])
                    }

                    return ""
                }))

                doc.autoTable({
                    startY: startY + 5,
                    head: headers,
                    body: reportData,
                    theme: 'plain',
                    tableWidth: 'wrap',
                    headStyles: {
                        lineWidth: 0.15,
                        cellPadding: 2,
                        rowHeight: 18
                    },
                    margin: { bottom: 30 },
                    styles: {
                        cellPadding: 1.0,
                        fontSize: 9,
                        halign: 'right',
                    },
                    columnStyles: colStyles,
                    didParseCell: function (data) {
                        if (data.row.section == 'body' && data.row.raw[0] == 'rowLine') {
                            data.cell.styles.fillColor = [0, 0, 0]
                            data.cell.styles.fontSize = 1
                            data.cell.styles.cellPadding = 0
                        } else if (data.row.section == 'body' && data.row.raw[0] && data.row.raw[0].content == 'Supplier Total :') {
                            data.cell.styles.fontStyle = 'bold'
                        }
                    }
                });

                startY = doc.lastAutoTable.finalY + 10
            });

            let printed_by = secureStorage.getItem("email")
            if (printed_by == null) {
                printed_by = ''
            }

            let pageCount = doc.internal.getNumberOfPages();
            for (let i = 1; i <= pageCount; i++) {
                doc.setPage(i);
                reportUtils.pdfTools.addFooter(doc, printed_by, "Sales Consignment Report", 525, 225, i, pageCount)
            }

            doc.save(`Sales_Consignment_Report_${moment().format('YYYYMMDDHHmmss')}.pdf`);
            this.spinning = false;
        },
        generateSalesConsignmentFile: async function () {
            this.spinning = true;
            const reportRows = await this.fetchSalesConsignmentReport()

            if (reportRows == null) {
                this.spinning = false;
                return
            }

            if (reportRows.length < 1) {
                reportUtils.openNotificationWithIcon(component_x, 'warning', 'Try increasing the scope by adjusting the filters.');
                this.spinning = false;
                return
            }

            this.JsonData = this.buildSalesConsignmentJson(reportRows)
            this.spinning = false;
        },
        async generateSalesConsignmentExcel() {
            const workbook = new ExcelJS.Workbook();
            workbook.created = new Date();
            workbook.modified = new Date();
            const sheet = workbook.addWorksheet("Sales Consignment Report", {
                pageSetup: { paperSize: 9 }
            });

            let { from_header, to_header } = reportUtils.buildFromToHeaders(component_x, this.inputGroupBy, this.inputDate)
            const data_starts_at_row = 8
            let reportLogo = document.getElementById('reportLogo');

            if (reportLogo) {
                const base64Image = reportUtils.csvxlsxTools.getBase64Image(reportLogo)
                const imageId2 = workbook.addImage({
                    base64: base64Image,
                    extension: 'png',
                });

                sheet.addImage(imageId2, {
                    tl: { col: 0, row: 0 },
                    ext: { width: 61, height: 61 }
                });
            }

            const headers = this.JsonData.length > 0 ? Object.keys(this.JsonData[0]) : this.getSalesConsignmentColumns().map(column => column.label)
            sheet.getRow(4).values = ["Sales Consignment Report"]
            sheet.getRow(5).values = [`For the Period of ${from_header} to ${to_header}`]
            sheet.getRow(6).values = [`Site/s: ${this.getSelectedSiteText()}`]
            sheet.getRow(7).values = [`Supplier/s: ${this.getSelectedSupplierText()}`]
            sheet.getRow(data_starts_at_row).values = headers;
            sheet.columns = headers.map(header => ({
                key: header,
                width: header == "Description" ? 40 : 18
            }))

            sheet.addRows(this.JsonData);

            sheet.getRow(4).font = { bold: true, size: 16 };
            sheet.getRow(4).height = 20;
            sheet.getRow(data_starts_at_row).font = { bold: true };
            sheet.eachRow(function (Row, rowNum) {
                if (rowNum >= data_starts_at_row) {
                    Row.eachCell(function (Cell) {
                        Cell.alignment = {
                            vertical: 'middle',
                            horizontal: rowNum == data_starts_at_row ? 'center' : 'left'
                        }
                        if (typeof Cell.value == "string" && Cell.value.indexOf("Supplier: ") == 0) {
                            Row.font = { bold: true }
                        } else if (typeof Cell.value == "string" && Cell.value == "Supplier Total :") {
                            Row.font = { bold: true }
                        }
                    })
                }
            })

            workbook.xlsx.writeBuffer().then(function (buffer) {
                const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                saveAs(blob, `salesConsignmentReport.xlsx`);
            });
            this.JsonData = []
        },
        getBase64Image(url) {
            const img = new Image();
            img.setAttribute('crossOrigin', 'anonymous');
            img.onload = () => {
                const canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;
                const ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0);
                canvas.toDataURL("image/png");
            }
            return img.src = url
        },
        clearJsonData() {
            this.JsonData = [];
        },
        addMaskValidation(value, rights) {
            if ((!this.accessCostPriceRights.includes('Z') && rights == 'Z') || (!this.accessCostPriceRights.includes('Y') && rights == 'Y')) {
                return '***';
            } else {
                return value
            }
        }
    }
};
</script>

<style></style>
